const getFechaDeString = (strDate) => {
  let resp = ''
  if (strDate === undefined) {
    return resp
  }
  const strSplit = strDate.split(' ')
  if (strSplit.length > 0) {
    resp = strSplit[0]
  }
  return resp
}

const getFechaActual = () => {
  const tzoffset = new Date().getTimezoneOffset() * 60000
  return new Date(Date.now() - tzoffset).toISOString().slice(0, 10)
}

const formatoMoneda = (valor) => {
  const valorConFormato = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0
  }).format(valor)

  return valorConFormato
}

export { getFechaDeString, getFechaActual, formatoMoneda }
